export const loadPersistedAccounts = (persistedAccounts, merchantCurrency) => {
  const currencyClaims = {};
  const persistedAccountKeys = [];
  const accounts = {};
  let defaultAccountKey;
  let merchantCurrencyAccountKey;

  const keyPrefix = `persisted-`;
  for (const { id, data: account } of persistedAccounts) {
    const key = `${keyPrefix}${id}`;
    persistedAccountKeys.push(key);

    if (!defaultAccountKey && account.isDefault) {
      defaultAccountKey = key;
    }

    const currency = account.currencyCode || account.currency;

    if (currency === merchantCurrency) {
      merchantCurrencyAccountKey = key;
    }

    currencyClaims[key] = currency;
    accounts[key] = {
      key,
      id,
      currency,
      accountHolder: account.accountHolder,
      accountNumber: account.accountNumber,
      bic: account.bic,
      routingNumber: account.routingNumber,
      transitNumber: account?.routingNumber?.substr(4, 5),
      institutionNumber: account?.routingNumber?.substr(1, 3),
    };
  }

  // we need to show the merchant country's currency always on top
  const sortedAccountsArray = Object.entries(accounts).sort(([key, _]) =>
    key === merchantCurrencyAccountKey ? -1 : 1,
  );

  const sortedAccounts = Object.fromEntries(sortedAccountsArray);

  return {
    autoDefaultAccountKey: merchantCurrencyAccountKey,
    defaultAccountKey,
    persistedAccountKeys,
    currencyClaims,
    accounts: sortedAccounts,
  };
};

export const usePersistedBankAccounts = (persistedAccounts, { merchantCurrency }) => {
  if (!persistedAccounts?.length) {
    const initialAccountKey = 'initial-0';
    return {
      autoDefaultAccountKey: initialAccountKey,
      defaultAccountKey: initialAccountKey,
      persistedAccountKeys: [],
      currencyClaims: { [initialAccountKey]: merchantCurrency },
      accounts: {
        [initialAccountKey]: {
          key: initialAccountKey,
          id: null,
          currency: merchantCurrency,
          accountHolder: '',
          accountNumber: '',
          bic: '',
          routingNumber: '',
        },
      },
    };
  }

  return loadPersistedAccounts(persistedAccounts, merchantCurrency);
};
